import React, {useState, useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual';
import axios from 'axios'
import swal from "sweetalert2";

const useLoad = (posid,zoneCollecte,setZoneCollecte) => {
    const t = useTranslate();
    const[zones,setZones] = useState([]);
    const[loading,setLoading] = useState(true)

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/zone/getall/"+posid
            ).then((response) => {
                //on récupère les mêmes zones que pour la réception (SelectZoneStock) : bons types, et uniquement sans bins
                let carZone = response.data.datas.filter(value=>['reception','stockage','commerciale','commande'].includes(value.type) && value.havebins==0)

                //si il n'y a qu'une seule zone éligible, on la sélectionne automatiquement
                if(carZone.length==1 && !zoneCollecte){
                    setZoneCollecte(carZone[0].id)
                }
                setZones(carZone)
                setLoading(false)
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
                setLoading(false)
            })
        })()
    }, [posid])

    return [zones,loading];
}

const SelectZoneCollecte = (props) =>{
    const t = useTranslate();
    const [zones,loading] = useLoad(props.posid,props.zoneCollecte,props.setZoneCollecte)

    //une seule zone (ou aucune) : résolution automatique, mais le select reste visible (désactivé, valeur pré-remplie)
    const noChoice = !loading && zones.length<=1

    return(
        <div className="form-group">
            <select value={props.zoneCollecte || ''} disabled={loading || noChoice} className='form-control' onChange={(e)=>props.setZoneCollecte(e.target.value)}>
                <option value="">-- Select --</option>
                {zones.map(value=>(
                    <option key={value.id} value={value.id}>{value.name}</option>
                ))}
            </select>
            <label>{props.labelMsg}</label>
        </div>
    )
}

export default SelectZoneCollecte;
